export default __webpack_public_path__ + "static/media/award.a796a64f.png";